"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z
    .object({
    year: zod_1.z.number(),
    blockId: zod_1.z.number(),
    overrideDate: zod_1.z.string().datetime().nullable(),
    calculationMethod: zod_1.z.string(),
})
    .array();
//# sourceMappingURL=update.js.map